import type { LogicalWarehouseSearchParams } from '../logical-warehouse/models/logical-warehouse.model';

export function mergeLogicalWarehouseListSearch(
  current: LogicalWarehouseSearchParams,
  formParams: { name?: string; code?: string; typeCodes?: string[] },
): LogicalWarehouseSearchParams {
  const searchName = formParams.name?.trim();
  const searchCode = formParams.code?.trim();
  return {
    ...current,
    name: searchName && searchName.length > 0 ? searchName : undefined,
    code: searchCode && searchCode.length > 0 ? [searchCode] : undefined,
    typeCodes: formParams.typeCodes || undefined,
    page: 0,
  };
}

export function logicalWarehouseListHasActiveFilters(
  p: Pick<LogicalWarehouseSearchParams, 'name' | 'code' | 'typeCodes'>,
): boolean {
  return !!(p.name || p.code || p.typeCodes);
}

export function resetLogicalWarehouseListSearch(
  size: number,
): Pick<
  LogicalWarehouseSearchParams,
  'name' | 'code' | 'typeCodes' | 'page' | 'size'
> {
  return {
    name: undefined,
    code: undefined,
    typeCodes: undefined,
    page: 0,
    size,
  };
}
